"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAppSection = void 0;
var react_1 = __importDefault(require("react"));
var createAppSection = function (config, _a) {
  var icons = _a.icons;
  var children = config.children || [];
  var showBreadcrumb = config.showBreadcrumb === undefined ? true : config.showBreadcrumb;
  var type = config.type || 'parent';
  var path = "".concat(config.path || config.id);
  // create an implicit child for the entity listing
  if (children.length === 0 && config.entityTypeName) {
    children.push({
      id: config.id,
      path: '',
      type: 'list',
      entityTypeName: config.entityTypeName
    });
    // the breadcrumb will be calculated for the entity from the child, so we switch this one off so it doesn't double-up.
    showBreadcrumb = false;
    type = 'list';
    // we'll pull the path from the entity
    path = '';
  }
  var definition = __assign(__assign({}, config), {
    showInNavigation: config.showInNavigation === undefined ? true : config.showInNavigation,
    showBreadcrumb: showBreadcrumb,
    path: path,
    icon: config.icon,
    type: type,
    scopes: config.scopes || [],
    navigation: config.navigation || 'header',
    children: children.map(function (child) {
      var icon = child.icon;
      if (!icon) {
        if (child.type === "list" && child.entityTypeName) {
          icon = function (_a) {
            var icons = _a.icons;
            return icons.Entities[child.entityTypeName];
          };
        }
      }
      // static pages don't have the platform prefix 
      return __assign(__assign({
        id: '',
        icon: icon,
        entityRoute: '',
        type: 'component',
        component: function () {
          return react_1.default.createElement(react_1.default.Fragment, null);
        }
      }, child), {
        path: "".concat(child.path || child.id || '')
      });
    })
  });
  return definition;
};
exports.createAppSection = createAppSection;